import type { EnterpriseAuthoringMappingsV1, PartnersV1 } from '__generated__/graphql-types-do-not-use';

import { COURSE_BUILDER_PARTNER_EXCLUSIONS } from 'bundles/teach-course-shared/utils/courseBuilderUtils';

export type EnterpriseAuthoringPartner = {
  __typename?: 'EnterpriseAuthoringMappingsV1';
  id: EnterpriseAuthoringMappingsV1['id'];
  partner?: Pick<PartnersV1, 'id' | 'name'> | null;
};

export const getPrivateAuthoringPartnerIdForCourseBuilder = (
  enterpriseAuthoringMappings?: (EnterpriseAuthoringPartner | null)[]
) => {
  return enterpriseAuthoringMappings?.find(
    (element) => element?.partner?.id && !COURSE_BUILDER_PARTNER_EXCLUSIONS.has(element.partner.id)
  )?.partner;
};
